import { Box, Grid, Stack, Tooltip, Typography } from "@mui/material";
import TicketsChart from "./chart";
import { ITicketReports } from "src/types/business-intelligence";

const TicketsStatistics = ({ data }: { data: ITicketReports | undefined }) => {
  return (
    <Stack
      borderRadius={"8px"}
      boxShadow={" 0px 2.232px 11.161px 0px rgba(0, 0, 0, 0.10)"}
      pt={{ xs: 2, lg: 3 }}
      pb={{ xs: 1, lg: 1 }}
      bgcolor={"#242424"}
    >
      <Grid container px={{ xs: 2, lg: 4 }} spacing={2}>
        <Grid item xs={6} sm={3}>
          <Typography
            fontSize={{ xs: "12px", lg: "14px" }}
            fontWeight={600}
            color={"#CFCFCF"}
          >
            Total Tickets
          </Typography>
          <Typography
            fontSize={{ xs: "16px", lg: "18px" }}
            fontWeight={500}
            color={"#FFF"}
          >
            {data?.total.totalTickets.toLocaleString()} Ticket
          </Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography
            fontSize={{ xs: "12px", lg: "14px" }}
            fontWeight={600}
            color={"#CFCFCF"}
          >
            Paid Tickets
          </Typography>

          <Typography
            fontSize={{ xs: "16px", lg: "18px" }}
            fontWeight={500}
            color={"#FFF"}
          >
            {data?.total.paidTickets.toLocaleString()} Ticket
          </Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography
            fontSize={{ xs: "12px", lg: "14px" }}
            fontWeight={600}
            color={"#CFCFCF"}
          >
            Free Tickets
          </Typography>

          <Typography
            fontSize={{ xs: "16px", lg: "18px" }}
            fontWeight={500}
            color={"#FFF"}
          >
            {data?.total.freeTickets.toLocaleString()} Ticket
          </Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography
            fontSize={{ xs: "12px", lg: "14px" }}
            fontWeight={600}
            color={"#CFCFCF"}
          >
            Refunded Tickets
          </Typography>
          <Typography
            fontSize={{ xs: "16px", lg: "18px" }}
            fontWeight={500}
            color={"#FFF"}
          >
            {data?.total.totalRefunded.toLocaleString()} Ticket
          </Typography>
        </Grid>
      </Grid>
      <Box
        width={"100%"}
        bgcolor={"#000000"}
        height={"2.3px"}
        my={{ lg: 3, xs: 2 }}
      />
      <TicketsChart data={data} />
    </Stack>
  );
};

export default TicketsStatistics;
